import { gql, makeVar } from '@apollo/client'

export const clientFeatureTogglesCache = makeVar({
  project: false,
  onboarding: false,
  knowledgeLibrary: false,
  impact: false,
  banner: false,
  anniversaryCard: false,
})

export const clientFeatureToggleGQL = gql`
  query {
    clientFeatureTogglesCache @client
  }
`
